import React from 'react';
import InputFactory from '../components/inputs/InputFactory';
import FormLabel from '../components/basicComponents/FormLabel';
import Attachments from '../components/inputs/Attachments';
import { getText } from '../utils/functions';
import { Checkbox } from '../../UI';

/* SHAREHOLDER DATA, COMMON TO EVERY FORM */
function ShareholderData({
	colors,
	formType,
	portal,
	formData,
	setFormData = () => { },
	translate,

	/* Optional props */
	classNameFORM = 'w-full md:pl-8 grid grid-flow-row lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10 items-end',
	styleLIST,
}) {
	const person = 'person';
	const entity = 'entity';

	const inputProps = {
		confirmError: getText(portal?.config?.validation?.confirmError, translate)
	};
	/* Get each input's configuation */
	const getInputConfig = React.useCallback(
		({ name, personType }) => portal?.config?.inputs?.[formType]?.[personType]
			?.find(
				element => element.name === name
			), [portal?.config, formType]
	);

	const styleCheckbox = {
		color: colors.text
	};
	const styleInCheckbox = {
		color: colors.primary
	};
	/* Get the dinamic inputs */
	const dinamicInputs = React.useCallback(inputConfig => inputConfig
		.filter(input => input.isActive)
		.filter(input => input.name !== 'personOrEntity' && input.name !== 'typeAssistance'), [portal?.config?.inputs?.[formType]]);

	const [followAssembly, setFollowAssembly] = React.useState(formData.followAssembly);

	React.useEffect(() => {
		setFormData({
			...formData,
			followAssembly
		});
	}, [followAssembly]);

	return <div className='flex flex-col space-y-8'>
		{/* ENTITY TYPE */}
		<FormLabel
			text={portal?.config?.forms?.participantData}
			colors={colors}
			translate={translate}
		/>
		{/* ENTITY INPUTS can be person or legal entity */}
		{getInputConfig({ name: 'personOrEntity', personType: formData.personOrEntity ? entity : person })?.isActive
			&& <InputFactory
				inputConfig={getInputConfig({ name: 'personOrEntity', personType: formData.personOrEntity ? entity : person })}
				personType={formData.personOrEntity ? entity : person}
				formData={formData}
				value={formData?.personOrEntity}
				setFormData={setFormData}
				colors={colors}
				translate={translate}
				inputProps={inputProps}
			/>}
		{getInputConfig({ name: 'typeAssistance', personType: formData.personOrEntity ? entity : person })?.isActive
			&& <InputFactory
				inputConfig={getInputConfig({ name: 'typeAssistance', personType: formData.personOrEntity ? entity : person })}
				personType={formData.personOrEntity ? entity : person}
				value={formData?.typeAssistance}
				formData={formData}
				setFormData={setFormData}
				colors={colors}
				translate={translate}
				inputProps={inputProps}
			/>}
		{/* CHECKBOX MUTUAMEDICA */}
		{/* {getInputConfig({ name: 'typeAssistance', personType: formData.personOrEntity ? entity : person })?.isActive && formType === 'access' && formData?.typeAssistance === 0 */}
		{false
			&& <Checkbox
				label={translate.follow_assembly_from_headquarters}
				value={followAssembly}
				onChange={() => setFollowAssembly(!followAssembly)}
				colors={colors}
				styleInLabel={styleCheckbox}
				colorBox={styleInCheckbox}
			/>
		}
		{/* ENTITY INPUTS can be person or legal entity */}
		<div className={classNameFORM} style={styleLIST}>
			{portal?.config?.inputs?.[formType]?.[formData.personOrEntity ? entity : person]
				&& dinamicInputs(portal.config.inputs[formType]
					?.[formData.personOrEntity ? entity : person]
				).map(inputConfig => <InputFactory
					portal={portal}
					inputConfig={inputConfig}
					formData={formData}
					setFormData={setFormData}
					value={formData[inputConfig.name]}
					personType={formData.personOrEntity ? entity : person}
					key={`${formType}_AttendanceInput_ENTITY_${inputConfig.name}`}
					colors={colors}
					translate={translate}
					inputProps={inputProps}
				/>)}
		</div>

		{/* ATTACHMENTS */}
		<Attachments
			portal={portal}
			personType={formData.personOrEntity ? entity : person}
			formType={formType}
			translate={translate}
			formData={formData}
			setFormData={setFormData}
			colors={colors}
		/>
	</div>;
}

export default ShareholderData;
